import { QuoteState } from '../../../enums/quoteState'

export const QUOTES_SUMMARY_BOXES_STATE: QuoteState[] = [QuoteState.Open, QuoteState.Closed, QuoteState.All]
